import React from 'react';
import { bundles } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';

const BundleSection = () => {
  return (
    <section id="bundles" className="py-24 bg-zinc-900 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-4">Trainer-Approved Protocols</h2>
          <p className="text-zinc-400 max-w-2xl mx-auto">Synergistic combinations designed for complete recovery coverage. Save when you build a comprehensive system.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {bundles.map(bundle => (
            <div key={bundle.id} className="flex flex-col md:flex-row bg-zinc-950 border border-zinc-800 rounded-sm overflow-hidden group">
              <div className="md:w-2/5 relative h-64 md:h-auto">
                <img 
                  src={bundle.image} 
                  alt={bundle.name} 
                  className="absolute inset-0 w-full h-full object-cover opacity-60 mix-blend-luminosity group-hover:opacity-80 transition-opacity"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent md:bg-gradient-to-r"></div>
              </div>
              
              <div className="p-8 md:w-3/5 flex flex-col justify-between relative z-10">
                <div>
                  <div className="inline-block bg-red-600/10 text-red-500 border border-red-600/20 px-2 py-1 text-xs font-bold uppercase mb-4">
                    Bundle & Save
                  </div>
                  <h3 className="text-2xl font-black uppercase tracking-tight mb-2">{bundle.name}</h3>
                  <ul className="space-y-2 mb-6">
                    {bundle.includes.map((item, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-zinc-400 text-sm">
                        <SafeIcon name="Check" className="text-red-500" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="flex items-center justify-between mt-auto pt-6 border-t border-zinc-800">
                  <div>
                    <span className="text-zinc-500 line-through text-sm mr-2">${bundle.originalPrice}</span>
                    <span className="text-2xl font-bold text-white">${bundle.price}</span>
                  </div>
                  <button className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-sm font-bold uppercase text-sm tracking-wider transition-colors">
                    Add Bundle
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BundleSection;